import { render, staticRenderFns } from "./randomPaper.vue?vue&type=template&id=dafe9d92&"
import script from "./randomPaper.vue?vue&type=script&lang=ts&"
export * from "./randomPaper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports